










































import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import XDialog from '@finance/ssvue/src/components/x-dialog/index.vue'
import IconTitle from '$components/icon-title'

const actModule = namespace('freeOrder')

@Component({
  name: 'prize-pop',
  components: {
    IconTitle,
    XDialog
  }
})
export default class RulePop extends Vue {
  @Prop({ default: false }) readonly value!: boolean
  @Prop() readonly couponList!: any[]
  @Prop() readonly freeLists!: any[]
  @actModule.Getter actConfig!: any
  @actModule.Getter actEnd!: boolean
  @actModule.Getter statistics!: any

  get isShowTitle() {
    return !(this.freeLists && this.freeLists.length > 0)
  }

  handleClickClose() {
    this.$emit('input', false)
  }
  // 获取免单券中间状态
  getCouponIsPrize(prizeId: string) {
    let result = '待开奖'
    if (this.actEnd) {
      for (const item of this.freeLists) {
        // @ts-ignore
        if (prizeId === item.prizeId) {
          result = '中奖啦'
          break
        } else {
          result = '未中奖'
        }
      }
    }

    return result
  }
  // 完成任务
  goTask() {
    this.handleClickClose()
    window.scrollTo({
      top: document.documentElement.clientHeight,
      behavior: 'smooth'
    })
  }
}
